export default {"src":"/_next/static/media/slide4.94c7dd26.svg","height":740,"width":757,"blurWidth":0,"blurHeight":0};